









































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    HOST
} from "../global";
@Component({
    name: "LandImg"
})
export default class LandImg extends Vue {
    //@Getter("pageData") public pageData!: pageDataType;
    @Prop() public compData!: string | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public HOST: string = HOST;

    scroll: any | null = null;

    public viewFrom() {
        window.scrollTo({
            top: 1000,
            left: 0,
            behavior: 'smooth'
        });

    }

}
